import React from "react";

import Footer from "../../components/Footer/DefaultFooter";
import Helmet from "../../components/Helmet";

import "../base.css";

export default ({ children, title, description, image }) => (
    <div>
        <Helmet
            title={ title }
            description={ description }
            image={ image }
        />
        <main
            css={{
                margin: "0 auto",
                padding: 15,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "calc(100vh)",
                maxWidth: 1000,
            }}
        >
            { children }
        </main>
        <Footer />
    </div>
);
